import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import MenuPage from "./pages/MenuPage";
import GivePointPage from "./pages/GivePointPage";
import CouponPage from "./pages/CouponPage";
import { getToken } from "./utils/auth";

function App() {
  const PrivateRoute = ({ children }) => {
    return getToken() ? children : <Navigate to="/" />;
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route
          path="/menu"
          element={
            <PrivateRoute>
              <MenuPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/give-point"
          element={
            <PrivateRoute>
              <GivePointPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/coupon"
          element={
            <PrivateRoute>
              <CouponPage />
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
